import { combineReducers } from 'redux';
import * as actionTypes from '../action-mgr/actionTypes';

const getStationIdFromAction = action =>
  action.stationId ||
  (action.findStationFields && action.findStationFields.stationId) ||
  null;

// Store last stationId for comparison
const lastStationId = (state = null, action) => {
  switch (action.type) {
    case actionTypes.GET_FIND_REALTIME_FIELDS_SUCCESS: {
      const stationId = getStationIdFromAction(action);
      return stationId !== null ? stationId : state;
    }
    default:
      return state;
  }
};

const selectFields = (state = [], action, lastStationIdState = null) => {
  switch (action.type) {
    case actionTypes.SELECT_FIELDS:
      return (state.indexOf(action.selectFields) > -1)
        ? [
            ...state.slice(0, state.indexOf(action.selectFields)),
            ...state.slice(state.indexOf(action.selectFields) + 1)
          ]
        : [
            ...state,
            action.selectFields
          ];
    case actionTypes.RESET_SELECT_FIELDS:
      return [];
    case actionTypes.GET_FIND_REALTIME_FIELDS_SUCCESS: {
      const stationId = getStationIdFromAction(action);
      // Only reset if stationId changed or state is empty (first load)
      if (stationId !== lastStationIdState || state.length === 0) {
        let defautlSelect = [];
        let counter = 0;
        if (action.findStationFields) {
          Object.entries(action.findStationFields).forEach(([key, value]) => {
            if (counter < 3 && value !== "") {
              defautlSelect.push(key);
              counter++;
            }
          });
        }
        return defautlSelect;
      }
      // Otherwise, keep current selection
      return state;
    }
    default:
      return state;
  }
};

const dashbaordWeatherInfo = (state = "", action) => {
  switch (action.type) {
    case actionTypes.GET_FIND_REALTIME_FIELDS_SUCCESS:
      return action.findDashboardWeather;
    default:
      return state;
  }
};

const realtimeEnergy = (state = "", action) => {
  switch (action.type) {
    case actionTypes.GET_FIND_REALTIME_FIELDS_SUCCESS:
      return action.energy;
    default:
      return state;
  }
};

const realtimeInverter = (state = "", action) => {
  switch (action.type) {
    case actionTypes.GET_FIND_REALTIME_FIELDS_SUCCESS:
      return action.inverter;
    default:
      return state;
  }
};

const findStationRealtimeFields = (state = [], action) => {
  switch (action.type) {
    case actionTypes.GET_FIND_REALTIME_FIELDS_SUCCESS:
      return [action.findStationFields];
    case actionTypes.GET_FIND_REALTIME_FIELDS_FAILURE:
      return [action.findStationFields];
    case actionTypes.REMOVE_FIELDS_FROM_SELECTIONS:
      var index = state.indexOf(action.key);
      return [
        ...state.slice(0, index),
        ...state.slice(index + 1)
      ];
    case actionTypes.CLEAR_FIELDS_SELECTIONS:
      return [];
    default:
      return state;
  }
};

const selectFieldsIndex = (state = ["1", "2", "3"], action, lastStationIdState = null) => {
  switch (action.type) {
    case actionTypes.SELECT_FIELDS_INDEX:
      return (state.indexOf(action.selectFieldsIndex) > -1)
        ? [
            ...state.slice(0, state.indexOf(action.selectFieldsIndex)),
            ...state.slice(state.indexOf(action.selectFieldsIndex) + 1)
          ]
        : [
            ...state,
            action.selectFieldsIndex
          ];
    case actionTypes.RESET_SELECT_FIELDS:
      return ["1", "2", "3"];
    case actionTypes.GET_FIND_REALTIME_FIELDS_SUCCESS: {
      const stationId = getStationIdFromAction(action);
      // Only reset if stationId changed or state is empty (first load)
      if (stationId !== lastStationIdState || state.length === 0) {
        if (action.findStationFields) {
          const keys = Object.keys(action.findStationFields);
          return keys.slice(0, 3).map((_, i) => (i + 1).toString());
        }
        return [];
      }
      // Otherwise, keep current selection
      return state;
    }
    default:
      return state;
  }
};

// Custom root reducer to pass lastStationId to selectFields/selectFieldsIndex
function stationFastData(state = {}, action) {
  const newLastStationId = lastStationId(state.lastStationId, action);
  return {
    ...state,
    lastStationId: newLastStationId,
    selectFields: selectFields(state.selectFields, action, state.lastStationId),
    findStationRealtimeFields: findStationRealtimeFields(state.findStationRealtimeFields, action),
    dashbaordWeatherInfo: dashbaordWeatherInfo(state.dashbaordWeatherInfo, action),
    realtimeEnergy: realtimeEnergy(state.realtimeEnergy, action),
    realtimeInverter: realtimeInverter(state.realtimeInverter, action),
    selectFieldsIndex: selectFieldsIndex(state.selectFieldsIndex, action, state.lastStationId),
  };
}

export default stationFastData;

const getCurrentState = state => state.stationFastData;

export const getSelectedField = state => getCurrentState(state).selectFields;
export const getFindStationRealtimeFields = state => getCurrentState(state).findStationRealtimeFields;
export const getDashbaordWeatherInfo = state => getCurrentState(state).dashbaordWeatherInfo;
export const getRealtimeEnergy = state => getCurrentState(state).realtimeEnergy;
export const getRealtimeInverter = state => getCurrentState(state).realtimeInverter;
export const getSelectFieldsIndex = state => getCurrentState(state).selectFieldsIndex;